export default __webpack_public_path__ + "static/media/restaurant-2-rMIN.81a38936.jpg";